import { make } from 'vuex-pathify';
import { state as productUpgrade } from '@/store/productUpgrade';

const getters = {
  ...make.getters(productUpgrade),
};

export { getters };
